import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { CondominiumsPetViewPage } from './condominiums-pet-view.page';

const routes: Routes = [
  {
    path: '',
    component: CondominiumsPetViewPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CondominiumsPetViewPage]
})
export class CondominiumsPetViewPageModule {}
